// src/pages/authPages/EmailVerifiedLoginPage.jsx
import React from "react";
import LoginPage from "./LoginPage";

// Destinazione del redirect backend dopo la conferma email (vedi server/routes/auth.js).
// L'account è già confermato quando l'utente arriva qui: nessuna validazione token,
// è solo una variante di LoginPage con titolo dedicato e senza link secondari.
export default function EmailVerifiedLoginPage() {
  return (
    <LoginPage
      title="Ci siamo quasi!"
      subtitle="La tua email è confermata. Accedi e scegli i servizi StirUp."
      cardTitle="Email verificata ✓"
      cardSubtitle="Accedi al tuo account per continuare."
      hideLinks
    />
  );
}
